import { Theme, css } from '@emotion/react';

export const textFieldRoot = ({ colors }: Theme) => css`
  & .MuiOutlinedInput-multiline {
    padding: 12.5px 10px;
  }
  & .MuiOutlinedInput-inputMultiline {
    padding: 0;
  }
  & .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.borderLight};
  }
  & .MuiOutlinedInput-input {
    padding: 12.5px 10px;
  }
  & .MuiOutlinedInput-input.Mui-disabled {
    background-color: ${colors.backgroundLightest};
  }

  & .MuiOutlinedInput-adornedStart {
    padding-left: 0;
  }

  & .MuiInputLabel-outlined {
    color: ${colors.textLight};
    transform: translate(14px, 12.5px) scale(1);
  }
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    color: ${colors.textLight};
    transform: translate(14px, -6px) scale(0.75);
  }
  & .MuiFormHelperText-contained {
    margin-left: 0;
  }
`;

export const helperTextWarning = ({ colors }: Theme) => css`
  & .MuiFormHelperText-root {
    color: ${colors.warning};
  }
`;

export const helperTextValid = ({ colors }: Theme) => css`
  & .MuiFormHelperText-root {
    color: ${colors.success};
  }
`;
